<script>
import axios from 'axios'
import _ from 'lodash'
export default
{
    name: 'mv-program-input',
    
    props:
    {
        value: null,
    },

    watch:
    {
        search(val)
        {
            this.fetch()
        },

        value(val)
        {
            this.internalValue = val
        },

        internalValue(val)
        {
            if (val && val != '')
            {
                this.addItem(val)
                // this.fetchItem(val)
                this.$emit('input', val)
            }
        },
    },

    methods:
    {
        fetch: _.debounce(function()
        {
            axios.get(`${process.env.API_URL}/v1/admin/programs/search`, { params: { search: this.search }}).then(res => {
                this.programs = res.data
            })
        }, 500),

        fetchItem(id)
        {
            axios.get(`${process.env.API_URL}/v1/admin/programs/${id}`).then(res => {
                this.selected = res.data
            })
        },

        addItem(id)
        {
            axios.post(`${process.env.API_URL}/v1/admin/recommendations`, { program_id: id }).then(res => {
                this.$emit('added')
            })
        },

    },

    data()
    {
        return {
            internalValue: this.value,
            search: null,
            programs: [],
            selected: {},
        }
    },
}
</script>
<template>
<div class="program-input">
    <!--
    <div class="program" v-if="internalValue && selected && selected.id">
        <img v-if="selected.attachments && selected.attachments[0]" :src="selected.attachments[0].display_url">
        {{ selected.name }}
    </div>
    -->
    <div class="row">
        <div class="col-xs-12">
            <div class="input-group">
                <span class="input-group-addon"><icon name="search"></icon></span>
                <input type="text" class="form-control" v-model="search">
            </div>
        </div>
    </div>
    <div class="row program-list" v-for="program in programs" :key="program.id">
        <div class="col-xs-12 program-item" @click="$set(program, 'class', 'green'); internalValue = program.id" :class="program.class">
            <div class="row">
                <div class="col-xs-4">
                    <strong>{{ program.name }}</strong>
                </div>
                <div class="col-xs-4">
                    {{ program.start }}
                </div>
                <div class="col-xs-4">
                    <template v-if="program.location && program.location.id">
                        {{ program.location.name }}
                    </template>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style lang="scss">
.program-input {

    .program {
        margin: .5em;
        background-color: #c2e3ea;
        padding: .5em;
        font-weight: bold;
        border-radius: 16px;
    }

    .program-list {
        margin-top: .5em;

        .program-item {
            background-color: lightgrey;
            padding: .5em;
            cursor: pointer;
            user-select: none;
            transition: background-color .5s;
            border-radius: 16px;

            &.green {
                background-color: green;

                &:hover {
                    background-color: lightgreen;
                }
            }

            &:hover {
                background-color: grey;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/ProgramInput.vue